import * as React from "react"
const SvgStopwatch = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M10 3.429a.97.97 0 0 1-.713-.288A.97.97 0 0 1 9 2.429a.97.97 0 0 1 .287-.713.97.97 0 0 1 .713-.287h4a.97.97 0 0 1 .713.287q.287.288.287.713c0 .425-.096.52-.287.712a.97.97 0 0 1-.713.288zm2 11a.97.97 0 0 0 .713-.288.97.97 0 0 0 .287-.713v-4a.97.97 0 0 0-.287-.712.97.97 0 0 0-.713-.287.97.97 0 0 0-.713.287.97.97 0 0 0-.287.713v4q0 .424.287.712.288.288.713.287Zm0 8a8.65 8.65 0 0 1-3.488-.713 9.2 9.2 0 0 1-2.862-1.938 9.2 9.2 0 0 1-1.938-2.862A8.65 8.65 0 0 1 3 13.428q0-1.85.712-3.487A9.2 9.2 0 0 1 5.65 7.079 9.2 9.2 0 0 1 8.512 5.14 8.65 8.65 0 0 1 12 4.429a8.9 8.9 0 0 1 2.975.5q1.425.5 2.675 1.45l.7-.7a.95.95 0 0 1 .7-.275q.425 0 .7.275a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7l-.7.7a9.7 9.7 0 0 1 1.45 2.675q.5 1.425.5 2.974a8.65 8.65 0 0 1-.712 3.488 9.2 9.2 0 0 1-1.938 2.863 9.2 9.2 0 0 1-2.863 1.937 8.65 8.65 0 0 1-3.487.712Zm0-2q2.9 0 4.95-2.05t2.05-4.95q0-2.901-2.05-4.95T12 6.429q-2.9 0-4.95 2.05T5 13.429t2.05 4.95 4.95 2.05" />
  </svg>
)
export default SvgStopwatch
